'use strict';

angular.module('adminModule')
.controller('NavbarController', NavbarController);

function NavbarController ($scope, Auth, BasketService, $state, kdGate, appConfig, twoFaSetup)
{
    $scope.currentUser = Auth.getCurrentUser();
    $scope.auth = Auth;
    $scope.basket = BasketService;

    $scope.menu = appConfig.theme.menu.filter((item) => {

        if (!item.href) {
            return false;
        }

        if (item.gate) {
            return kdGate.allows(item.gate);
        }

        return  true;
    });

    $scope.gotoRootFolder = (stateName, event) =>
    {
        if ($state.current.name !== stateName) {
            return;
        }

        event.preventDefault();
        $state.go($state.current, {folder_id: 0}, {reload: true, inherit: false});
    };

    $scope.twoFaAuth = function ()
    {
        twoFaSetup.showModal();
    };
}


